import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

// TNSR-635 (AiProjectPlanningModal's auto-provision-on-first-use path): that caller reads
// response.createApiKey.apiKey.node.key/.active straight off commitMutation's onCompleted
// callback, not through useFragment — a masked spread hands back an opaque
// {" $fragmentRefs": ... } record there, not a plain object, so key/active silently read as
// undefined and resolvedApiKey never gets set. @relay(mask: false) flattens the fragment's
// fields onto node directly, the same way settings_api_keys.js's own list already reads this
// exact fragment.
const mutation = graphql`
	mutation createApiKeyMutation($input: CreateApiKeyInput!) {
		createApiKey(input: $input) {
			apiKey {
				node {
					...settingsApiKeys_apiKey @relay(mask: false)
				}
			}
		}
	}
`;

function getConfigs(companyId) {
	return [
		{
			type: 'RANGE_ADD',
			parentID: companyId,
			connectionInfo: [
				{
					key: 'Company_apiKeys',
					rangeBehavior: 'append',
				},
				{
					key: 'PrimaryNavigationRightCompany_apiKeys',
					rangeBehavior: 'append',
				},
			],
			edgeName: 'apiKey',
		},
	];
}

function commit(environment, companyId, onSuccess, onError) {
	tracking.trackEvent('Api Key Created');
	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId()}},
		configs: getConfigs(companyId),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
